import React, { useEffect, useRef, useState } from 'react';
import { Button, Input, Select, Space, Form, Row, Col } from 'antd';
import { getTrainers } from '../../services/trainerServices';
import TrainerTable from './TrainerTable';
import TrainerAdd from './TrainerAdd';
import { Link } from 'react-router-dom';

const { Option } = Select;

const PAGE_SIZE = 20;

function Trainers() {
  const [form] = Form.useForm();

  const totalCount = useRef(null);
  const [trainer, setTrainer] = useState([]);
  const [status, setStatus] = useState('LOADING');
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [pagination, setPagination] = useState({
    pageNo: 1,
    pageSize: PAGE_SIZE,
  });

  useEffect(() => {
    fetchData(pagination.pageNo, pagination.pageSize);
  }, [pagination]);

  const fetchData = (pageNo, pageSize, param) => {
    setStatus('LOADING');
    getTrainers(pageNo, pageSize, param)
      .then((response) => {
        totalCount.current = response.data.totalCount;
        setTrainer(response.data.paginatedList);
        setStatus('SUCCESS');
      })
      .catch((error) => {
        console.log('Error getting data from the admin backend:', error);
        alert('Getting data from the backend failed!');
        setStatus('ERROR');
      });
  };

  function onPaginationChange(data) {
    setPagination({
      pageNo: data.current,
      pageSize: data.pageSize,
    });
  }

  function onSearch(data) {
    fetchData(1, PAGE_SIZE, { [data.param]: data.val });
  }

  function onReset() {
    form.resetFields();
    fetchData(1, PAGE_SIZE);
  }

  function toggleAddModal() {
    setIsAddModalOpen((prev) => !prev);
  }

  return (
    <div>
      <Row justify="space-between">
        <Space size="large">
          <h1>Trainers</h1>
        </Space>
        <Link
          to="/trainer-public-profiles"
          style={{ textDecoration: 'underline' }}
        >
          Public Profiles
        </Link>
      </Row>
      <Row justify="space-between">
        <h3>Total {totalCount.current} Record(s)</h3>
        <Button type="primary" onClick={toggleAddModal}>
          Add Trainer
        </Button>
      </Row>
      <section className="grey-section">
        <Form form={form} onFinish={onSearch}>
          <Row gutter={16}>
            <Col span={4}>
              <Form.Item name="param" rules={[{ required: true }]}>
                <Select placeholder="Search by...">
                  <Option value="firstName">First Name</Option>
                  <Option value="lastName">Last Name</Option>
                  <Option value="trainerId">Trainer Id</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item name="val" rules={[{ required: true }]}>
                <Input placeholder="Enter the search term..." />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Search
                </Button>
                <Button htmlType="button" onClick={onReset}>
                  Reset
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </section>
      <section>
        <TrainerTable
          data={trainer}
          onPaginationChange={onPaginationChange}
          loading={status === 'LOADING' ? true : false}
          totalCount={totalCount.current}
        />
      </section>
      <TrainerAdd isOpen={isAddModalOpen} toggle={toggleAddModal} />
    </div>
  );
}

export default Trainers;
